"use strict";

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _WebformEdit = _interopRequireDefault(require("./Webform.edit.conditions"));

var _WebformEdit2 = _interopRequireDefault(require("./Webform.edit.variables"));

var _utils = _interopRequireDefault(require("../../components/_classes/component/editForm/utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  for (var _len = arguments.length, extend = new Array(_len), _key = 0; _key < _len; _key++) {
    extend[_key] = arguments[_key];
  }

  var components = _lodash.default.cloneDeep([{
    type: 'tabs',
    key: 'tabs',
    components: [{
      label: 'Conditions',
      key: 'conditions',
      weight: 0,
      components: _WebformEdit.default
    }, {
      label: 'Variables',
      key: 'variables',
      weight: 10,
      components: _WebformEdit2.default
    }]
  }]).concat(extend.map(function (items) {
    return {
      type: 'tabs',
      key: 'tabs',
      components: _lodash.default.cloneDeep(items)
    };
  }));

  return {
    components: _lodash.default.unionWith(components, _utils.default.unifyComponents)
  };
};

exports.default = _default;